import React from 'react'

import StudentEvents from '../../components/StudentTabs/StudentEvents/StudentEvents'
const Events = () => {
  return (
    <div>
        <StudentEvents />
    </div>
  )
}

export default Events